import { render, staticRenderFns } from "./InfoPanel.vue?vue&type=template&id=8ea707a6&scoped=true&"
import script from "./InfoPanel.vue?vue&type=script&lang=ts&"
export * from "./InfoPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea707a6",
  null
  
)

export default component.exports